<template>
  <div v-if="step !== 4" class="align-items-center text-center">
    <p class="titleLabel">Paso {{ step }} de 3 - {{ textStep }}</p>
  </div>

  <form
    v-if="firstStep"
    role="form"
    autocomplete="off"
    @submit.prevent="onSubmitFirstStep"
  >
    <div>
      <div class="row" v-if="!notSupport">
        <!-- <div class="descriptionLabel">
          Comprueba si tu pana, novia o vecino tiene cobertura de Xtrim
        </div> -->
        <div
          class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
          style="margin: 10px 0"
        >
          <label
            for="example-text-input"
            class="form-control-label"
            :class="purpleLabel"
            style="font-weight: 900; font-size: 12px"
            >Dirección (*):</label
          >

          <GMapAutocomplete
            :value="autocomplete"
            placeholder="Dirección domiciliaria"
            @place_changed="getAddressData"
            required
            :readonly="isDisabled"
            class="form-control col-lg-12"
          />
        </div>
        <div v-if="loading" class="loading-container">
          <div class="loader"></div>
          <!-- Animated spinner -->
          <p>
            Estamos buscando tu ubicación, acepta el uso de geolocalización en
            tu dispositivo
          </p>
        </div>
        <div
          class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
          style="margin-bottom: 10px"
          v-else
        >
          <label
            for="example-text-input"
            class="form-control-label"
            :class="purpleLabel"
            style="font-weight: 900; font-size: 12px"
            >Ubica el marcador (*):</label
          >

          <GMapMap
            @click="mark"
            :center="center"
            :zoom="16"
            map-type-id="terrain"
            style="width: 100%; height: 250px"
            v-if="!loadingAutocomplete"
            :options="{
              zoomControl: true,
              mapTypeControl: true,
              scaleControl: true,
              streetViewControl: true,
              rotateControl: true,
              fullscreenControl: true,
              disableDefaultUi: true,
            }"
          >
            <GMapMarker
              :key="index"
              v-for="(m, index) in markers"
              :position="m.position"
              :clickable="true"
              :draggable="true"
              @click="center = m.position"
              @dragend="handleMarkerDrag"
            />
          </GMapMap>
        </div>

        <div
          class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
          align="center"
        >
          <button
            type="submit"
            id="btn_solicitar"
            class="btn btn-primary"
            style="width: 100%"
            :disabled="isDisabled"
          >
            Siguiente
            <i style="margin-left: 10px" class="fas fa-arrow-circle-right"></i>
          </button>
        </div>
      </div>

      <div v-else class="row">
        <div
          class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
          align="center"
        >
          <svg
            width="100"
            height="100"
            viewBox="-20 0 190 190"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M38.155 140.475 48.988 62.1108l43.881 4.946 18.568 23.955-8.041 57.1092L38.155 140.475zM84.013 94.0018 88.827 71.8068l-34.781-3.5-9.854 67.1502L98.335 142.084l6.542-45.2752-20.864-2.807zM59.771 123.595C59.394 123.099 56.05 120.299 55.421 119.433 64.32 109.522 86.05 109.645 92.085 122.757 91.08 123.128 86.59 125.072 85.71 125.567 83.192 118.25 68.445 115.942 59.771 123.595zM76.503 96.4988 72.837 99.2588l-5.515-6.642L59.815 96.6468l-3.029-5.069L63.615 88.1508l-4.526-5.452L64.589 79.0188 68.979 85.4578 76.798 81.5328 79.154 86.2638l-7.047 3.783 4.396 6.452z"
              fill="#4a4a4a"
            />
          </svg>

          <div
            class="alert alert-primary"
            role="alert"
            style="margin: 0px; font-size: 12px"
          >
            <p
              style="
                text-align: center;
                font-size: 14px;
                margin: 0px;
                color: #f9cc03;
              "
            >
              Tu navegador no soporta la API de geolicación. Por favor intente
              con el navegador Chrome, Brave, Mozilla u otro.
            </p>
          </div>
        </div>
      </div>
    </div>
  </form>

  <form
    v-if="secondStep"
    role="form"
    autocomplete="off"
    @submit.prevent="onSubmitSecondStep"
  >
    <div class="row">
      <!-- Client Type Selection -->
      <div
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style="margin-bottom: 20px"
      >
        <label
          for="client-type"
          class="form-control-label"
          style="
            font-weight: 900;
            font-size: 14px;
            margin-bottom: 10px;
            display: block;
          "
          :class="purpleLabel"
          >Tipo de cliente (*):</label
        >

        <div class="client-type-container">
          <div class="client-type-option">
            <input
              type="radio"
              id="natural"
              v-model="clientType"
              value="natural"
              class="client-type-radio"
            />
            <label for="natural" class="client-type-label">
              <i class="fas fa-user client-type-icon"></i>
              Persona Natural
            </label>
          </div>

          <div class="client-type-option">
            <input
              type="radio"
              id="company"
              v-model="clientType"
              value="company"
              class="client-type-radio"
            />
            <label for="company" class="client-type-label">
              <i class="fas fa-building client-type-icon"></i>
              Persona Jurídica
            </label>
          </div>
        </div>
      </div>

      <!-- Natural Person Fields -->
      <template v-if="clientType === 'natural'">
        <div
          class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6"
          style="margin-bottom: 10px"
        >
          <label
            for="example-text-input"
            class="form-control-label"
            style="font-weight: 900; font-size: 12px"
            :class="purpleLabel"
            >Cédula (*):</label
          >
          <input
            placeholder="Ingrese su cédula"
            class="form-control col-lg-12"
            required
            type="tel"
            @keypress="NumbersOnly"
            @input="validateDNI"
            autocomplete="off"
            v-model="dni"
          />
        </div>

        <div
          class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6"
          style="margin-bottom: 10px"
        >
          <label
            for="example-text-input"
            class="form-control-label"
            style="font-weight: 900; font-size: 12px"
            :class="purpleLabel"
            >Código Dactilar (*):</label
          >
          <input
            placeholder="Código Dactilar"
            class="form-control col-lg-12 text-uppercase"
            required
            type="text"
            maxlength="10"
            @input="validateFingerPrintCode"
            autocomplete="off"
            v-model="fingerPrintCode"
          />
        </div>

        <div
          class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
          style="margin-bottom: 10px"
        >
          <label
            for="example-text-input"
            class="form-control-label"
            style="font-weight: 900; font-size: 12px"
            :class="purpleLabel"
            >Nombre completo (*):</label
          >
          <input
            required
            placeholder="Ingrese nombres y apellidos"
            class="form-control col-lg-12"
            type="text"
            autocomplete="off"
            v-model="displayName"
          />
        </div>
      </template>

      <!-- Company Fields -->
      <template v-if="clientType === 'company'">
        <div
          class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
          style="margin-bottom: 10px"
        >
          <label
            for="example-text-input"
            class="form-control-label"
            style="font-weight: 900; font-size: 12px"
            :class="purpleLabel"
            >RUC (*):</label
          >
          <input
            placeholder="Ingrese RUC (13 dígitos, debe terminar en 001)"
            class="form-control col-lg-12"
            required
            type="tel"
            @keypress="NumbersOnly"
            @input="validateRUC"
            autocomplete="off"
            v-model="ruc"
          />
          <small v-if="rucError" class="text-danger">{{ rucError }}</small>
        </div>

        <div
          class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
          style="margin-bottom: 10px"
        >
          <label
            for="example-text-input"
            class="form-control-label"
            style="font-weight: 900; font-size: 12px"
            :class="purpleLabel"
            >Razón Social (*):</label
          >
          <input
            required
            placeholder="Ingrese la razón social de la empresa"
            class="form-control col-lg-12"
            type="text"
            autocomplete="off"
            v-model="displayName"
          />
        </div>
      </template>

      <div
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style="margin-bottom: 10px"
      >
        <label
          for="example-text-input"
          class="form-control-label"
          style="font-weight: 900; font-size: 12px"
          :class="purpleLabel"
          >Número celular (*):</label
        >
        <MazPhoneNumberInput
          type="tel"
          default-country-code="EC"
          style="width: 100%"
          no-flags
          no-example
          required
          show-code-on-list
          size="sm"
          v-model="phoneNumber"
          @update="results = $event"
          :translations="{
            countrySelector: {
              placeholder: 'Código',
              error: 'Elija un pais',
            },
            phoneInput: {
              placeholder: 'Nro. celular',
              example: 'Ejemplo:',
            },
          }"
        />
      </div>

      <div
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style="margin-bottom: 10px"
      >
        <label
          for="example-text-input"
          class="form-control-label"
          style="font-weight: 900; font-size: 12px"
          :class="purpleLabel"
          >Correo electrónico (*):</label
        >
        <input
          placeholder="Ingrese su correo electrónico"
          class="form-control col-lg-12"
          required
          type="email"
          autocomplete="off"
          v-model="email"
        />
      </div>

      <div
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style="margin-bottom: 10px"
      >
        <label
          for="example-text-input"
          class="form-control-label"
          style="font-weight: 900; font-size: 12px"
          :class="purpleLabel"
          >Dirección:</label
        >
        <input
          placeholder="Dirección"
          class="form-control col-lg-12"
          type="text"
          autocomplete="off"
          v-model="autocomplete"
          disabled
        />
      </div>

      <div
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style="margin-bottom: 10px"
      >
        <label
          for="example-text-input"
          class="form-control-label"
          style="font-weight: 900; font-size: 12px"
          :class="purpleLabel"
          >Calle Principal (*):</label
        >
        <input
          placeholder="Calle Principal"
          class="form-control col-lg-12"
          required
          type="text"
          autocomplete="off"
          v-model="mainSt"
        />
      </div>

      <div
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style="margin-bottom: 10px"
      >
        <label
          for="example-text-input"
          class="form-control-label"
          style="font-weight: 900; font-size: 12px"
          :class="purpleLabel"
          >Calle Secundaria (*):</label
        >
        <input
          placeholder="Calle Secundaria"
          class="form-control col-lg-12"
          required
          type="text"
          autocomplete="off"
          v-model="secondarySt"
        />
      </div>

      <div
        class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6"
        style="margin-bottom: 10px"
      >
        <label
          for="example-text-input"
          class="form-control-label"
          style="font-weight: 900; font-size: 12px"
          :class="purpleLabel"
          >Manzana:</label
        >
        <input
          placeholder="Manzana"
          class="form-control col-lg-12"
          type="text"
          autocomplete="off"
          v-model="block"
        />
      </div>

      <div
        class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6"
        style="margin-bottom: 10px"
      >
        <label
          for="example-text-input"
          class="form-control-label"
          style="font-weight: 900; font-size: 12px"
          :class="purpleLabel"
          >Villa:</label
        >
        <input
          placeholder="Villa"
          class="form-control col-lg-12"
          type="text"
          autocomplete="off"
          v-model="lotNumber"
        />
      </div>

      <div
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style="margin-bottom: 10px"
      >
        <label
          for="example-text-input"
          class="form-control-label"
          style="font-weight: 900; font-size: 12px"
          :class="purpleLabel"
          >Referencia:</label
        >
        <input
          placeholder="Referencia"
          class="form-control col-lg-12"
          type="text"
          autocomplete="off"
          v-model="reference"
        />
      </div>

      <div
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        align="center"
        style="justify-content: space-between; display: flex; margin-top: 12px"
      >
        <button
          @click="goBack"
          class="btn btn-secondary"
          :disabled="isDisabled"
        >
          <i style="margin-right: 10px" class="fas fa-arrow-circle-left"></i>
          Atrás
        </button>

        <button
          type="submit"
          id="btn_second_step"
          class="btn btn-yellow-normal"
          :disabled="isDisabled || !isSecondStepValid"
        >
          Siguiente
          <i style="margin-left: 10px" class="fas fa-arrow-circle-right"></i>
        </button>
      </div>
    </div>
  </form>

  <form
    v-if="thirdStep"
    role="form"
    autocomplete="off"
    @submit.prevent="onSubmit"
  >
    <div class="row">
      <div
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style="margin-bottom: 20px"
      >
        <label
          for="services-selection"
          class="form-control-label"
          :class="purpleLabel"
          style="
            font-weight: 900;
            font-size: 14px;
            margin-bottom: 10px;
            display: block;
          "
          >Selecciona los servicios que deseas contratar (*):</label
        >

        <div class="services-container">
          <div class="service-option">
            <input
              type="checkbox"
              id="internet"
              v-model="servicesSelected.internet"
              class="service-checkbox"
            />
            <label for="internet" class="service-label">
              <i class="fas fa-wifi service-icon"></i>
              Internet
            </label>
          </div>

          <div class="service-option">
            <input
              type="checkbox"
              id="zapping"
              v-model="servicesSelected.tv"
              class="service-checkbox"
            />
            <label for="zapping" class="service-label service-label--zapping">
              <img
                :src="zappingLogo"
                alt=""
                class="zapping-service-logo"
                width="28"
                height="28"
              />
              Zapping
            </label>
          </div>
        </div>

      </div>

      <div
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style="margin-bottom: 20px"
      >
        <label
          for="budget"
          class="form-control-label"
          :class="purpleLabel"
          style="font-weight: 900; font-size: 12px"
          >Presupuesto mensual ($) (*):</label
        >
        <select
          id="budget"
          class="form-control col-lg-12"
          required
          v-model="budget"
        >
          <option value="" disabled>Selecciona un presupuesto</option>
          <option value="10-20">$10 - $20</option>
          <option value="20-30">$20 - $30</option>
          <option value="30-50">$30 - $50</option>
          <option value="50-80">$50 - $80</option>
        </select>
      </div>

      <div
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style="margin-bottom: 20px"
      >
        <label
          for="description"
          class="form-control-label"
          :class="purpleLabel"
          style="font-weight: 900; font-size: 12px"
          >Descripción:</label
        >
        <textarea
          id="description"
          class="form-control col-lg-12 auto-expand-textarea"
          placeholder="Información adicional sobre la solicitud ej: El cliente desea servicio de internet y zapping. (opcional)"
          v-model="description"
          rows="3"
          style="min-height: 80px; resize: none; overflow: hidden"
          @input="autoExpand"
        ></textarea>
      </div>

      <div
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        align="center"
        style="justify-content: space-between; display: flex; margin-top: 12px"
      >
        <button
          @click="goBackToSecondStep"
          class="btn btn-secondary"
          :disabled="isDisabled"
        >
          <i style="margin-right: 10px" class="fas fa-arrow-circle-left"></i>
          Atrás
        </button>

        <button
          type="submit"
          id="btn_submit"
          class="btn btn-yellow-normal"
          :disabled="isDisabled || !isValidServiceSelection"
        >
          Solicitar servicio
        </button>
      </div>
    </div>
  </form>

  <div v-if="step === 4" class="resultContainer">
    <p class="titleLabel">¡Tu solicitud se envió exitosamente!</p>

    <p
      style="
        font-weight: 600;
        font-size: 16px;
        padding: 10px 20px 0 20px;
        text-align: center;
        margin: 0 0 10px 0;
      "
      class="purplePlainText"
    >
      En breve un asesor se contactará con tu cliente para continuar la
      contratación.
    </p>
    <p
      style="
        color: white;
        font-weight: 500;
        font-size: 14px;
        padding: 10px 20px 10px 20px;
        text-align: center;
        margin: 10px 0 0 0;
        max-width: 370px;
        text-align: center;
        background-color: #540355;
        border-radius: 12px;
      "
    >
      Si tienes alguna duda o inconveniente, no dudes en escribirnos por
      <a
        target="_blank"
        href="https://api.whatsapp.com/send?phone=593995756176&text=Hola,%20necesito%20ayuda..."
        style="color: #19b251; font-weight: 700"
        >Whatsapp
        <svg
          width="22"
          style="margin-left: 6px"
          height="22"
          viewBox="0 0 16 16"
          xmlns="http://www.w3.org/2000/svg"
          fill="#19b251"
        >
          <path
            d="M13.601 2.326A7.854 7.854.0 007.994.0C3.627.0.068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933.0 003.79.965h.004c4.368.0 7.926-3.558 7.93-7.93A7.898 7.898.0 0013.6 2.326zM7.994 14.521a6.573 6.573.0 01-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251A6.56 6.56.0 011.407 7.922c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56.0 014.66 1.931 6.557 6.557.0 011.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729.0 00-.529.247c-.182.198-.691.677-.691 1.654.0.977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"
          />
        </svg>
      </a>
    </p>
  </div>
</template>

<script>
/*eslint-disable */

import { debounce } from "lodash";
import zappingLogo from "@/assets/img/Xtrim/zapping.svg";

export default {
  name: "Venta",
  components: {},
  props: ["promoCode", "tokenAuth", "onDashboard"],
  data() {
    return {
      zappingLogo,
      isDisabled: false,
      displayName: "",
      dni: "",
      step: 1,
      phoneNumber: null,
      firstStep: true,
      secondStep: false,
      thirdStep: false,
      results: null,
      hasPhone: false,
      email: "",
      textStep: "Verificación de Cobertura",
      Ubication: [],
      center: {},
      markers: [],
      geocoder: null,
      loadMap: true,
      plusCode: "",
      notSupport: false,
      city: "",
      autocomplete: "",
      emailRespaldo: "",
      phoneRespaldo: "",
      idVenta: "",
      loading: true,
      loadingAutocomplete: true,
      isMapLoaded: false,
      isGponAvailable: false,
      mainSt: "",
      secondarySt: "",
      block: "",
      lotNumber: "",
      reference: "",
      fingerPrintCode: "",
      userId: this.$store.state.user.userId,
      servicesSelected: {
        internet: false,
        tv: false,
        phone: false,
      },
      budget: "",
      description: "",
      clientType: "natural",
      ruc: "",
      rucError: "",
    };
  },
  methods: {
    getAddressData(request) {
      this.autocomplete = request.formatted_address;
      let location = request.geometry.location;

      this.center = {
        lat: parseFloat(request.geometry.location.lat()),
        lng: parseFloat(request.geometry.location.lng()),
      };

      this.markers = [
        {
          position: location,
        }, // Along list of clusters
      ];

      this.geocoder
        .geocode({ location: this.center })
        .then((response) => {
          if (response.results[0]) {
            this.plusCode = response.results[0].formatted_address;
            this.autocomplete = response.results[1].formatted_address;
            this.city = response.results[0].address_components[2].long_name;
          }
        })
        .catch((e) => console.log("Geocoder failed due to: " + e));
    },

    loadMapa() {
      this.loading = true;
      if (this.loadMap) {
        this.loadMap = false;

        if (!("geolocation" in navigator)) {
          this.$toast.error(
            "La geolocalización no está soportado para este navegador",
            {
              position: "top-right",
              max: 10,
            },
          );

          this.notSupport = true;

          return;
        }

        // get position
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            this.center = {
              lat: parseFloat(pos.coords.latitude),
              lng: parseFloat(pos.coords.longitude),
            };

            this.markers = [
              {
                position: {
                  lat: parseFloat(pos.coords.latitude),
                  lng: parseFloat(pos.coords.longitude),
                },
              }, // Along list of clusters
            ];

            this.geocoder
              .geocode({ location: this.center })
              .then((response) => {
                if (response.results[0]) {
                  this.plusCode = response.results[0].formatted_address;
                  this.autocomplete = response.results[1].formatted_address;
                  this.city =
                    response.results[0].address_components[2].long_name;
                }
              })
              .catch((e) => console.log("Geocoder failed due to: " + e))
              .finally(() => {
                this.loading = false;
              });
          },
          (err) => {
            this.loading = false;
            this.$toast.error(err.message, {
              position: "top-right",
              timeout: 3010,
              closeOnClick: true,
              pauseOnFocusLoss: false,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.4,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: "button",
              icon: true,
              rtl: false,
            });
          },
        );
      }
    },

    loadAutocomplete(retryCount = 0, maxRetries = 10) {
      console.log("Load autocomplete attempt:", retryCount);
      if (retryCount >= maxRetries) {
        this.$toast.error(
          "No se pudo cargar Google Maps API después de varios intentos.",
          {
            position: "top-right",
            timeout: 5000,
          },
        );
        return;
      }
      this.loadingAutocomplete = true;

      if (!("geolocation" in navigator)) {
        this.$toast.error(
          "La geolocalización no está soportado para este navegador",
          {
            position: "top-right",
            max: 10,
          },
        );

        this.notSupport = true;

        return;
      }
      if (typeof google === "undefined" || !google.maps) {
        console.log("Google Maps API no está disponible. Reintentando...");
        setTimeout(() => {
          this.loadAutocomplete(retryCount + 1, maxRetries);
        }, 1000); // Retry after 1 second
        return;
      }

      // get position
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          this.center = {
            lat: parseFloat(pos.coords.latitude),
            lng: parseFloat(pos.coords.longitude),
          };

          this.markers = [
            {
              position: {
                lat: parseFloat(pos.coords.latitude),
                lng: parseFloat(pos.coords.longitude),
              },
            }, // Along list of clusters
          ];
          this.geocoder = new google.maps.Geocoder();

          this.geocoder
            .geocode({ location: this.center })
            .then((response) => {
              if (response.results[0]) {
                this.plusCode = response.results[0].formatted_address;
                this.autocomplete = response.results[1].formatted_address;
                this.city = response.results[0].address_components[2].long_name;
              }
            })
            .catch((e) => console.log("Geocoder failed due to: " + e))
            .finally(() => {
              this.loading = false;
              this.loadingAutocomplete = false;
            });
        },
        (err) => {
          this.loadingAutocomplete = false;
          if (err.message === "User denied Geolocation") {
            this.$toast.error(
              "Geolocalización rechazada, actívala para poder usar el sitio",
              {
                position: "top-right",
                timeout: 6010,
                closeOnClick: true,
                pauseOnFocusLoss: false,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.4,
                showCloseButtonOnHover: false,
                hideProgressBar: true,
                closeButton: "button",
                icon: true,
                rtl: false,
              },
            );
          } else {
            this.$toast.error(err.message, {
              position: "top-right",
              timeout: 3010,
              closeOnClick: true,
              pauseOnFocusLoss: false,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.4,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: "button",
              icon: true,
              rtl: false,
            });
          }
        },
      );
    },

    handleMarkerDrag(e) {
      this.center = {
        lat: parseFloat(e.latLng.lat()),
        lng: parseFloat(e.latLng.lng()),
      };

      this.geocoder
        .geocode({ location: this.center })
        .then((response) => {
          if (response.results[0]) {
            this.plusCode = response.results[0].formatted_address;
            this.autocomplete = response.results[1].formatted_address;
            this.city = response.results[0].address_components[2].long_name;
          }
        })
        .catch((e) => console.log("Geocoder failed due to: " + e));
    },

    mark(event) {
      this.center = {
        lat: parseFloat(event.latLng.lat()),
        lng: parseFloat(event.latLng.lng()),
      };

      this.markers = [
        {
          position: {
            lat: parseFloat(event.latLng.lat()),
            lng: parseFloat(event.latLng.lng()),
          },
        }, // Along list of clusters
      ];

      this.geocoder
        .geocode({ location: this.center })
        .then((response) => {
          if (response.results[0]) {
            this.plusCode = response.results[0].formatted_address;
            this.city = response.results[0].address_components[2].long_name;
            this.autocomplete = response.results[1].formatted_address;
          }
        })
        .catch((e) => console.log("Geocoder failed due to: " + e));
    },

    onSubmit(event) {
      event.preventDefault();

      if (this.hasPhone) {
        document.getElementById("btn_submit").innerHTML =
          '<i class="fas fa-spinner fa-pulse"></i>  Solicitando';

        this.isDisabled = true;

        this.$https
          .post("/sales/registerSale/", {
            userId: this.userId,
            displayName: this.displayName,
            phone: this.phoneNumber,
            email: this.email,
            address: this.autocomplete,
            latitude: this.center.lat,
            longitude: this.center.lng,
            plusCode: this.plusCode,
            city: this.city,
            isGponAvailable: this.isGponAvailable,
            mainSt: this.mainSt,
            secondarySt: this.secondarySt,
            block: this.block,
            lotNumber: this.lotNumber,
            reference: this.reference,
            clientType: this.clientType,
            dni: this.clientType === "natural" ? this.dni : null,
            fingerPrintCode:
              this.clientType === "natural" ? this.fingerPrintCode : null,
            ruc: this.clientType === "company" ? this.ruc : null,
            servicesSelected: this.servicesSelected,
            budget: this.budget,
            description: this.description,
          })
          .then((response) => {
            document.getElementById("btn_submit").innerHTML =
              "Solicitar servicio";
            this.isDisabled = false;
            if (!this.onDashboard) {
              this.$swal({
                title: response.data.message,
                icon: "success",
                showCancelButton: false,
                confirmButtonText: "Entendido",
                focusConfirm: true,
                allowEscapeKey: false,
                allowOutsideClick: false,
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                buttonsStyling: false,
              });
            }

            this.secondStep = false;
            this.firstStep = false;
            this.thirdStep = false;
            this.step = 4;
            this.$eventBus.emit("reiniciarListadoVentas");
          })
          .catch((error) => {
            document.getElementById("btn_submit").innerHTML =
              "Solicitar servicio";
            this.isDisabled = false;
            console.log("error", error.response.data.message);
            this.$toast.error(
              error.response.data.message ?? "Ocurrió un error inesperado",
              {
                position: "top-right",
                max: 10,
              },
            );
          });
      } else {
        this.$toast.error("El número celular es un campo obligatorio", {
          position: "top-right",
          max: 10,
        });
      }
    },

    onSubmitSecondStep(event) {
      event.preventDefault();
      this.step = 3;
      this.firstStep = false;
      this.secondStep = false;
      this.thirdStep = true;
      this.textStep = "Selección de servicios";
    },

    goBack() {
      if (this.step === 2) {
        this.step = 1;
        this.isGponAvailable = false;
        this.firstStep = true;
        this.secondStep = false;
        this.thirdStep = false;
        this.textStep = "Verificación de Cobertura";
      }
    },

    goBackToSecondStep() {
      if (this.step === 3) {
        this.step = 2;
        this.firstStep = false;
        this.secondStep = true;
        this.thirdStep = false;
        this.textStep = "Información general";
      }
    },

    async onSubmitFirstStep(event) {
      event.preventDefault();

      this.isDisabled = true;

      document.getElementById("btn_solicitar").innerHTML =
        '<i class="fas fa-spinner fa-pulse"></i>  Comprobando cobertura';

      const { COVERAGE_API_URL } = await import("@/store/axios");
      const axios = (await import("axios")).default;

      axios
        .post(COVERAGE_API_URL + "sales/checkCoverage/", {
          tokenAuth: this.tokenAuth,
          latitude: this.center.lat,
          longitude: this.center.lng,
        })
        .then((response) => {
          document.getElementById("btn_solicitar").innerHTML =
            'Siguiente <i  style="margin-left: 10px;" class="fas fa-arrow-circle-right"></i>';
          this.isDisabled = false;

          if (response.data.code == 200) {
            this.isDisabled = false;
            this.step = 2;
            this.firstStep = false;
            this.secondStep = true;
            this.thirdStep = false;
            this.textStep = "Información general";
            this.isGponAvailable = response.data.isGponAvailable;
          } else {
            if (response.data.code == 405) {
              this.$swal({
                title: response.data.message,
                icon: "warning",
                showCancelButton: false,
                confirmButtonText: "Entendido",
                focusConfirm: true,
                allowEscapeKey: false,
                allowOutsideClick: false,
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                buttonsStyling: false,
              });
            } else {
              this.$toast.error(response.data.message, {
                position: "top-right",
                max: 10,
              });
              document.getElementById("btn_solicitar").innerHTML =
                'Siguiente <i  style="margin-left: 10px;" class="fas fa-arrow-circle-right"></i>';
            }
          }
        })
        .catch((error) => {
          this.isDisabled = false;
          document.getElementById("btn_solicitar").innerHTML =
            'Siguiente <i  style="margin-left: 10px;" class="fas fa-arrow-circle-right"></i>';
          this.$toast.error("Ocurrio un error " + error, {
            position: "top-right",
            max: 10,
          });
        });
    },

    validateDNI() {
      if (this.dni.length > 10) {
        this.dni = this.dni.slice(0, 10);
      }
    },

    NumbersOnly(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    validateFingerPrintCode() {
      if (this.fingerPrintCode.length > 10) {
        this.fingerPrintCode = this.fingerPrintCode.slice(0, 10).toUpperCase();
      }
    },

    validateRUC() {
      if (this.ruc.length > 13) {
        this.ruc = this.ruc.slice(0, 13);
      }
      if (this.ruc.length === 13) {
        if (!this.ruc.endsWith("001")) {
          this.rucError = "El RUC debe terminar en 001";
        } else {
          this.rucError = "";
        }
      }
    },

    autoExpand(e) {
      const textarea = e.target;
      // Reset height to auto to get the correct scrollHeight
      textarea.style.height = "auto";
      // Set the height to match content (adding a little extra space)
      textarea.style.height = textarea.scrollHeight + "px";
    },

  },
  computed: {
    canEnterFingerprint() {
      return !(this.dni && this.dni.length === 10 && this.dniExists);
    },
    isAnyServiceSelected() {
      return this.servicesSelected.internet || this.servicesSelected.tv;
    },
    isValidServiceSelection() {
      return this.servicesSelected.internet || this.servicesSelected.tv;
    },
    isSecondStepValid() {
      if (this.clientType === "natural") {
        return (
          this.dni.length === 10 &&
          this.displayName.trim().length > 0 &&
          this.fingerPrintCode.trim().length > 0
        );
      } else if (this.clientType === "company") {
        return (
          this.ruc.length === 13 &&
          this.ruc.endsWith("001") &&
          this.displayName.trim().length > 0
        );
      }
      return false;
    },
  },
  watch: {
    results(newValue) {
      if (newValue.isValid) {
        this.phoneNumber = newValue.e164;
        this.hasPhone = true;

        // this.checkPhone();
      } else {
        this.hasPhone = false;
      }
    },
    displayName() {
      this.displayName = this.displayName.toUpperCase();
    },
    clientType(newValue) {
      // Clear fields when switching client type
      if (newValue === "natural") {
        this.ruc = "";
        this.rucError = "";
      } else if (newValue === "company") {
        this.dni = "";
        this.fingerPrintCode = "";
      }
      this.displayName = "";
    },
  },
  mounted() {
    // this.cargarScript();
    // this.instanceMap();
    this.loadAutocomplete();
    this.debouncedGetAddressData = debounce(this.getAddressData, 300); // 300 ms debounce

    // Initialize textarea height after component is mounted
    this.$nextTick(() => {
      const textarea = document.getElementById("description");
      if (textarea && this.description) {
        textarea.style.height = "auto";
        textarea.style.height = textarea.scrollHeight + "px";
      }
    });
  },
  created() {},
  beforeUnmount() {},
};
</script>

<style scoped>
.loading-container {
  text-align: center;
  margin-top: 20px;
}

.loader {
  border: 5px solid #f9cc03; /* Light grey */
  border-top: 5px solid #7d0c7e; /* Blue color */
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
  margin: 20px auto;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-container p {
  font-size: 16px;
  color: white;
}

.resultContainer {
  width: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 20px;
}
/* .pinkPurpleText {
  padding: 5px 10px;
  background: rgb(170, 50, 189);
  background: linear-gradient(
    68deg,
    rgba(170, 50, 189, 1) 0%,
    rgb(226, 80, 232) 100%
  );
  border: 2px solid #ec62ea;
  color: white;
  font-family: Ubuntu;
  font-weight: 300;
  margin: 0 10px;
  border-radius: 16px;
  gap: 8px;
  margin-top: 8px;
  text-align: center;
  width: fit-content;
  font-size: 14px;
  font-weight: 900;
} */

.descriptionLabel {
  text-align: center;
  font-family: "Inter", "Segoe UI", sans-serif;
  font-weight: 600;
  color: #333333;
  font-size: 14px;
  background-color: #f3f3f3; /* soft neutral background */
  border-radius: 6px;
  padding: 6px 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  width: fit-content;
  margin: 0 auto;
  letter-spacing: 0.2px;
}

.purpleLabel {
  color: #7d0c7e;
}
.yellowLabel {
  color: #f9cc03;
}

/* :deep(.m-phone-number-input.--responsive .m-input-wrapper) {
  border: 2px solid #f9cc03 !important;
} */

:deep(.m-select-chevron) {
  margin-left: 8px !important;
}

:deep(.m-select-input__toggle-button .maz-custom) {
  padding: 0 !important;
}

:deep(.m-input-wrapper-right) {
  padding: 0 !important;
}

.titleYellowText {
  text-align: center;
  font-family: Ubuntu;
  font-weight: 900;
  color: #7d0c7e;
  font-size: 14px;
  text-shadow:
    2px 2px 0px white,
    -2px -2px 0px white,
    2px -2px 0px white,
    -2px 2px 0px white;
  background: #f9cc03;
  border-radius: 12px;
  padding: 3px 12px;
  box-shadow: 0px 2px 10px 2px #7c0c7e48;
}

.titleLabel {
  text-align: center;
  font-family: "Inter", "Segoe UI", sans-serif;
  font-weight: 600;
  color: #7d0c7e;
  font-size: 14px;
  background-color: #f4f1f7; /* light muted background for subtle contrast */
  border-radius: 8px;
  padding: 6px 12px;
  box-shadow: 0 1px 4px rgba(125, 12, 126, 0.1);
  width: fit-content;
  margin: 0 auto;
  margin-bottom: 10px;
  letter-spacing: 0.2px;
}

.purplePlainText {
  color: #7d0c7e;
}

.whitePlainText {
  color: white;
}

.services-container {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 15px;
}

.service-option {
  flex: 1;
  min-width: 120px;
  position: relative;
}

.service-checkbox {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.service-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px 10px;
  background-color: #f8f9fa;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  height: 100%;
}

.service-checkbox:checked + .service-label {
  background-color: #f9eeff;
  border-color: #7d0c7e;
  color: #7d0c7e;
}

.service-icon {
  font-size: 24px;
  margin-bottom: 8px;
  color: #7d0c7e;
}

.zapping-service-logo {
  display: block;
  width: 28px;
  height: 28px;
  object-fit: contain;
  margin-bottom: 8px;
}

.service-label--zapping {
  font-weight: 700;
  color: #7d0c7e;
}

.auto-expand-textarea {
  transition: height 0.2s ease-in-out;
  font-family: inherit;
  line-height: 1.5;
  padding: 8px 12px;
}

.auto-expand-textarea:focus {
  outline: none;
  border-color: #7d0c7e;
  box-shadow: 0 0 0 0.2rem rgba(125, 12, 126, 0.25);
}

.client-type-container {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
}

.client-type-option {
  flex: 1;
  position: relative;
}

.client-type-radio {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.client-type-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px 10px;
  background-color: #f8f9fa;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  height: 100%;
  font-weight: 600;
  font-size: 14px;
}

.client-type-radio:checked + .client-type-label {
  background-color: #f9eeff;
  border-color: #7d0c7e;
  color: #7d0c7e;
}

.client-type-icon {
  font-size: 24px;
  margin-bottom: 8px;
  color: #7d0c7e;
}
</style>
